import {TTrack} from "../types";
import API from "./api";

export async function searchTrack(query: string): Promise<Array<TTrack>> {

    return API.get("/api/tracks/search", {
        "params": {
            name: query
        }
    }).then((response) => {
        return Promise.resolve(response.data as Array<TTrack>);
    }).catch(error => {
        return Promise.reject(error);
    });

};